
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_471_5809)"}},[_c('path',{attrs:{"d":"M12.6745 4.15189L12.6189 10.5156C12.6172 10.7149 12.5364 10.9053 12.3942 11.0449C12.2521 11.1846 12.0603 11.2621 11.8611 11.2603C11.6618 11.2586 11.4715 11.1778 11.3318 11.0356C11.1921 10.8935 11.1146 10.7017 11.1164 10.5025L11.157 5.95068L4.604 12.3903C4.46212 12.5297 4.27068 12.6071 4.07177 12.6053C3.87287 12.6036 3.6828 12.5229 3.54338 12.381C3.40396 12.2392 3.32661 12.0477 3.32834 11.8488C3.33008 11.6499 3.41076 11.4598 3.55263 11.3204L10.1056 4.8808L5.55337 4.83975C5.35412 4.83801 5.16372 4.75719 5.02406 4.61507C4.8844 4.47295 4.80691 4.28117 4.80865 4.08192C4.81039 3.88267 4.89121 3.69227 5.03333 3.55261C5.17545 3.41295 5.36723 3.33547 5.56648 3.33721L11.9302 3.39274C12.029 3.39349 12.1266 3.41375 12.2176 3.45234C12.3085 3.49094 12.3909 3.54713 12.4601 3.61767C12.5292 3.68821 12.5838 3.77171 12.6206 3.86339C12.6574 3.95507 12.6757 4.05311 12.6745 4.15189Z","fill":"#10001F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_471_5809"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":"white"}})])])])
          )
        }
      }
    